import styled from "styled-components";

export const ProjectDetailsStyled = styled.div`
  .flex {
    display: flex;
  }
  .tab-content {
    padding: 12px 36px !important;
    min-height: 100vh;
  }
  .delete-icon {
    display: flex;
    justify-content: end;
  }

  .head-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .footer {
    padding: 20px;
    padding-top: 0;
    position: sticky;
    bottom: 0;
    width: -webkit-fill-available;
    background: var(--flow-30-neutral-white, #FFF);
    z-index: 1;

    hr{
      margin: 0;
      margin-bottom: 16px !important
    }

    .space-between {
      display: flex;
      justify-content: space-between;

      .created {
        display: flex;
        flex-direction: column;
      }
    }
  }
`;
